import { stripeAccountStatus } from "../enums/stripeAccountStatusEnum";
import api from "./BaseServices";

const API_URL = `${process.env.REACT_APP_API_URL}/stripe`;

export interface requestBoosterQuantity {
  boosterId: string;
  quantity: number;
}

export const createStripeAccount = async () => {
  const response = await api.post(`${API_URL}/account`);
  return response.data;
};

export const createStripeAccountLink = async () => {
  const response = await api.post(`${API_URL}/accountLink`);
  return response.data;
};

export const getStripeAccountStatus =
  async (): Promise<stripeAccountStatus> => {
    const CACHE_TTL_MS = 60 * 1000; // 1 minute
    const userStr = localStorage.getItem("user");
    let user = userStr ? JSON.parse(userStr) : null;

    // Return immediately if status is already completed
    if (user?.stripeAccountStatus === stripeAccountStatus.completed) {
      return stripeAccountStatus.completed;
    }

    const now = Date.now();
    const lastUpdate = user?.lastDateUpdate
      ? new Date(user.lastDateUpdate).getTime()
      : 0;
    const shouldFetch = now - lastUpdate > CACHE_TTL_MS;

    let status: stripeAccountStatus =
      user?.stripeAccountStatus ?? stripeAccountStatus.not_created;

    if (shouldFetch || !user) {
      try {
        const response = await api.get(`${API_URL}/status`);
        status = response.data.status;

        // Update localStorage cache
        const updatedUser = {
          ...(user ?? {}),
          stripeAccountStatus: status,
          lastDateUpdate: new Date().toISOString(),
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      } catch (error) {
        console.error("Failed to fetch Stripe account status", error);
        // Optional: Handle specific fallback behavior here
      }
    }

    return status;
  };

export const createStripeLoginLink = async () => {
  const response = await api.get(`${API_URL}/loginLink`);
  return response.data;
};

export const createStripeSession = async (items: requestBoosterQuantity[]) => {
  const response = await api.post(`${API_URL}/session`, items);
  return response.data;
};

export const createStripeShippingSession = async (
  items: requestBoosterQuantity[]
) => {
  const response = await api.post(`${API_URL}/shipping-session`, items);
  return response.data;
};

export const createTransfer = async () => {
  const response = await api.post(`${API_URL}/transfer`);
  return response.data;
};
